export const faqs = [
  {
    question: "Comment est-ce que je reçois le matériel ?",
    answer:
      "Dès la confirmation du paiement, vous recevez un e-mail avec l'accès pour télécharger les deux guides et les 5 bonus en PDF, prêts à imprimer ou à utiliser sur tablette.",
  },
  {
    question: "Y a-t-il des vidéos, des audios ou des cours collectifs ?",
    answer:
      "Non. Le pack est exclusivement composé de fichiers PDF : pas de vidéos, pas d'audios et pas de cours collectifs. Vous recevez tout immédiatement par e-mail.",
  },
  {
    question: "Est-ce utile si je commence tout juste à enseigner ?",
    answer:
      "Oui. Le Guide Théorique est justement conçu pour vous donner une structure claire dès le premier cours, quelle que soit votre expérience.",
  },
  {
    question: "Pour quels âges sont les exercices ?",
    answer:
      "Le Guide Pratique comprend des exercices pour les enfants dès 6 ans, les adolescents et les adultes, organisés par niveau et non par âge.",
  },
  {
    question: "Est-ce un paiement unique ou un abonnement ?",
    answer:
      "C'est un paiement unique de 27 USD. Aucun frais mensuel ni coût caché : le matériel vous appartient pour toujours.",
  },
  {
    question: "Comment fonctionne la garantie ?",
    answer:
      "Vous avez 10 jours pour découvrir tout le matériel. S'il ne vous convient pas, écrivez-nous et nous vous remboursons 100 %, sans questions.",
  },
  {
    question: "Puis-je imprimer les fiches pour mes élèves ?",
    answer:
      "Oui, vous pouvez imprimer les fiches et exercices autant de fois que nécessaire pour vos propres élèves.",
  },
];
